




































































import Vue from 'vue'
import Carousel from '@/common/components/Carousel.vue'
import { Swiper } from 'swiper'
import { ProductSkuImage } from '@/product/types'
import Drift from 'drift-zoom'
import ProductImagesPreview from '@/product/components/productSlider/ProductImagesPreview.vue'

export default Vue.extend({
  components: {
    Carousel,
    ProductImagesPreview
  },
  props: {
    imageList: {
      type: Array as () => ProductSkuImage[],
      required: true
    },
    currentImageIndex: {
      type: Number,
      required: true
    },
    isMobileView: {
      type: Boolean,
      required: true
    },
    productName: {
      type: String,
      required: true
    },
    viewProgress: {
      type: String,
      required: true
    }
  },
  data(): {
    swiper?: Swiper
    showPreviewImages: boolean
    driftInstance?: Drift
  } {
    return {
      swiper: undefined,
      showPreviewImages: false,
      driftInstance: undefined
    }
  },
  computed: {
    carouselActiveIndex(): number {
      return this.swiper?.realIndex || 0
    }
  },
  watch: {
    currentImageIndex() {
      this.swiper?.slideToLoop(this.currentImageIndex, 500)
    }
  },
  mounted() {
    this.swiper = (this.$refs.prProductImagesCarousel as any)?.swiper
    this.swiper?.on('slideChange', () => {
      this.$emit('changeImage', this.carouselActiveIndex)
      this.$nextTick(() => this.initDriftInstance())
    })
    this.initDriftInstance()
  },
  methods: {
    openPreviewImages() {
      if (!this.isMobileView) return
      this.showPreviewImages = true
    },
    closePreviewImages(activeIndex: number) {
      this.showPreviewImages = false
      this.swiper?.slideTo(activeIndex, 0, false)
    },
    initDriftInstance() {
      if (this.isMobileView) return
      if (this.driftInstance) {
        this.driftInstance.destroy()
        this.driftInstance = undefined
      }
      const triggerEl = (document.getElementsByClassName(
        'swiper-slide-active'
      ) as HTMLCollectionOf<HTMLElement>)[0]?.querySelector('img')

      if (triggerEl) {
        this.driftInstance = new Drift(triggerEl, {
          paneContainer: this.$refs.zoomContainer as HTMLElement,
          zoomFactor: 3,
          hoverDelay: 250,
          hoverBoundingBox: true
        })
      }
    }
  }
})
